document.addEventListener('DOMContentLoaded', function () {
  
  if (!window.location.href.includes("/collections/")) {
    sessionStorage.setItem('parent_link', 0 );
  }
  
  let menuLinks = document.querySelectorAll('.header__menu__nav .nav .menu a');  
  menuLinks.forEach((menuLink) => {
    menuLink.addEventListener('click', () => {
      sessionStorage.setItem('parent_link', 0 );
    });
  });
  
});